import React from 'react';
import { Target, Lightbulb, TrendingUp } from 'lucide-react';

const About = () => {
  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            About <span className="text-blue-500">MidSkale</span>
          </h2>
          <p className="text-xl text-slate-600 max-w-3xl mx-auto">
            Scaling Digital Success for Modern Enterprises
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-slate-900">
              Transforming Enterprises Through Technology
            </h3>
            <p className="text-lg text-slate-600 leading-relaxed">
              MidSkale is a technology consulting firm specializing in enterprise resource planning, 
              technical staffing, and custom software development. We partner with organizations to 
              modernize their operations, streamline processes, and unlock growth through strategic 
              technology implementations.
            </p>
            <p className="text-lg text-slate-600 leading-relaxed">
              With over 15 years of deep expertise in Oracle ERP, NetSuite, and JD Edwards, combined 
              with cutting-edge AI and cloud capabilities, we deliver solutions that drive measurable 
              business outcomes.
            </p>
          </div>

          <div className="grid gap-6">
            <div className="bg-gradient-to-br from-blue-50 to-cyan-50 p-8 rounded-2xl border border-blue-100 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <Target className="text-blue-500 mb-4" size={32} />
              <h4 className="text-xl font-bold text-slate-900 mb-2">Our Mission</h4>
              <p className="text-slate-600">
                Empower businesses to achieve operational excellence through innovative ERP solutions, 
                world-class talent, and intelligent automation.
              </p>
            </div>

            <div className="bg-gradient-to-br from-slate-50 to-blue-50 p-8 rounded-2xl border border-slate-200 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <Lightbulb className="text-blue-500 mb-4" size={32} />
              <h4 className="text-xl font-bold text-slate-900 mb-2">Our Expertise</h4>
              <p className="text-slate-600">
                We serve Fortune 500 companies across manufacturing, retail, healthcare, finance, 
                and technology sectors with proven implementation methodologies.
              </p>
            </div>

            <div className="bg-gradient-to-br from-cyan-50 to-blue-50 p-8 rounded-2xl border border-cyan-100 hover:shadow-xl transition-all duration-300 hover:scale-105">
              <TrendingUp className="text-blue-500 mb-4" size={32} />
              <h4 className="text-xl font-bold text-slate-900 mb-2">Our Approach</h4>
              <p className="text-slate-600">
                Agile, collaborative, and results-driven. We deliver faster implementations with 
                higher quality through proven frameworks and dedicated teams.
              </p>
            </div>
          </div>
        </div>

        {/* Industries Served */}
        <div className="mt-16">
          <h3 className="text-2xl font-bold text-slate-900 text-center mb-8">Industries We Serve</h3>
          <div className="flex flex-wrap justify-center gap-4">
            {['Manufacturing', 'Retail', 'Healthcare', 'Finance', 'Technology', 'Logistics', 'Energy', 'Telecommunications'].map((industry) => (
              <div
                key={industry}
                className="px-6 py-3 bg-slate-100 hover:bg-blue-50 border border-slate-200 hover:border-blue-300 rounded-full text-slate-700 hover:text-blue-600 font-medium transition-all duration-300 hover:scale-105 cursor-default"
              >
                {industry}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;